<template>
  <section class="city-lab network-module-create">
    <nav class="lab-crumb">网格平台 / 新增网格案例</nav>
    <lab-panel title="新增网格案例">
      <template #actions><router-link class="btn small" :to="backTo">{{ backLabel }}</router-link></template>
      <p class="lab-note">填写案例名称并选择案例类型后，进入基本信息、部门、人力、地理、网格、指标、事件和评分八大系统配置。</p>
      <operation-message :value="error" type="error" @consumed="error = ''" />
      <form class="network-module-create-form" :aria-busy="busy" @submit.prevent="create">
        <label class="lab-field" for="network-module-name">案例名称 <em>*</em>
          <input id="network-module-name" ref="name" v-model="name" :disabled="busy" maxlength="100" required placeholder="如：商圈食品安全与市容管理实训案例" autocomplete="off">
        </label>
        <label class="lab-field" for="network-module-case-type">案例类型 <em>*</em>
          <select id="network-module-case-type" v-model="caseType" :disabled="busy || typesLoading || !!typesError" required>
            <option v-for="item in caseTypes" :key="item" :value="item">{{ item }}</option>
          </select>
        </label>
        <label v-if="caseType === '教师自定义'" class="lab-field" for="network-module-custom-type">具体案例类型 <em>*</em>
          <input id="network-module-custom-type" v-model="customCaseType" :disabled="busy" maxlength="50" required placeholder="如：社区养老服务、校园周边治理" autocomplete="off">
          <small v-if="customCaseType.trim() === '教师自定义'" class="danger">请填写具体的案例类型名称。</small>
        </label>
        <p v-if="typesLoading" class="lab-hint">正在加载案例类型…</p>
        <p v-if="typesError" class="lab-error" role="alert">案例类型加载失败：{{ typesError }} <button class="btn small" type="button" @click="loadCaseTypes">重新加载</button></p>
        <p class="lab-hint">新案例为本人私有草稿，完成配置并发布后，可在实训任务管理中分配给学生。</p>
        <div class="lab-button-row"><button class="btn primary" type="submit" :disabled="busy || !name.trim() || !resolvedCaseType || typesLoading || !!typesError">{{ busy ? '正在创建…' : '创建并配置' }}</button><router-link v-if="!busy" class="btn" :to="backTo">取消</router-link></div>
      </form>
    </lab-panel>
  </section>
</template>

<script>
import LabPanel from '../components/NetworkLabPanel.vue'
import { api, errorText } from '../services/api'

export default {
  name: 'NetworkModuleCreate', components: { LabPanel },
  data () { return { name: '', caseType: '', customCaseType: '', caseTypes: [], typesLoading: true, typesError: '', busy: false, error: '', createdId: '' } },
  computed: {
    backTo () { return this.$route.query.from === 'library' ? '/cases' : '/network/modules' },
    backLabel () { return this.$route.query.from === 'library' ? '返回实训案例库' : '返回实训任务管理' },
    resolvedCaseType () { const value = this.caseType === '教师自定义' ? this.customCaseType.trim() : this.caseType; return value === '教师自定义' ? '' : value }
  },
  mounted () { this.$refs.name.focus(); this.loadCaseTypes() },
  beforeRouteLeave (to, from, next) { next(!this.busy || !!this.createdId) },
  methods: {
    async loadCaseTypes () {
      this.typesLoading = true; this.typesError = ''
      try {
        const result = await api.get('/network/modules')
        this.caseTypes = result.caseTypes || []
        if (!this.caseTypes.length) throw new Error('暂无可用的案例类型')
        if (!this.caseTypes.includes(this.caseType)) this.caseType = this.caseTypes[0]
      } catch (error) { this.typesError = errorText(error) }
      finally { this.typesLoading = false }
    },
    async create () {
      if (this.busy || !this.name.trim() || !this.resolvedCaseType || this.typesLoading || this.typesError) return
      this.busy = true; this.error = ''
      try {
        if (!this.createdId) this.createdId = (await api.post('/network/modules', { name: this.name.trim(), caseType: this.resolvedCaseType })).id
        await this.$router.replace('/network/modules/' + encodeURIComponent(this.createdId)); this.$message.success('案例已创建，可以开始配置')
      } catch (error) { this.error = errorText(error) }
      finally { this.busy = false }
    }
  }
}
</script>
